import { Analysis } from "../models/general/analysis";
import { translate } from "../translate/translate";
import { formatter } from "./formatter-utils";

/**
 * Description of an analysis as shown in the GDS listing column.
 *
 * Every screen that names an analysis reads from here, so the wording stays the
 * same across the listing, the materials filter and the dashboard selector.
 */
export const formatAnalysisDescription = (analysis: Partial<Analysis>): string => {
  const date = formatter.formatDate(analysis.forecast_date || "");
  const period = analysis.effective_period !== undefined && analysis.effective_period !== null
    ? analysis.effective_period
    : (analysis.period || 0);
  const boms = analysis.boms ? analysis.boms.length : 0;

  return translate.t("analysis_description_template", {
    date,
    period,
    boms,
    interpolation: { escapeValue: false },
  });
};
